import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLScriptComponent } from 'ml-components-common-react';
import { MLUWIssuesPanelComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import PropTypes from 'prop-types';
import metadata from './AvailableDocumentsComponent.metadata.json5';
import messages from './AvailableDocumentsComponent.messages';
import styles from './AvailableDocumentsComponent.module.scss';

const AvailableDocumentsComponent = (props) => {
    const { 
        availableDocumentsForms,
        isUserRetentionAgent,
        convertDateToUTC,
        scriptML,
        viewDocument,
        uwIssues,
        quoteID,
        blockingUWIssuesPresentCallback,
        approvedAllBlockingUWIssuesCallback,
        submissionVM,
        setIsFileUploadDone,
        updateWizardData
    } = props;

    const translator = useTranslator();

    const [filteredForms, setFilteredForms] = useState([]);
    const [contingencies, setcontingencies] = useState(submissionVM?.value?.preBindContingenciesToDTO || []);
   
    if(contingencies?.length>0){
        setIsFileUploadDone(true);
    }
    useEffect(() => {
        setFilteredForms(_.filter(availableDocumentsForms, (form) => {
            return !!form.signatureType.value;
        }));
    }, [setFilteredForms, availableDocumentsForms]);

    const generateAdFormsOverrides = () => {
        const getTypeKeyDescription = (typeKeyName) => {
            return translator({
                id: typeKeyName,
                defaultMessage: typeKeyName
            });
        };

        const overrides = filteredForms.map((adForm, index) => {
            return {
                [`formDescription${index}`]: {
                    content: adForm.formDescription.value
                },
                [`isSignedIcon${index}`]: {
                    visible: adForm.isSigned.value === true
                },
                [`signatureType${index}`]: {
                    className: adForm.isSigned.value === true ? 'ml-bold' : undefined,
                    content: getTypeKeyDescription(adForm.signatureType.value.name)
                },
                [`userRetentionAgentDateSignedContainer${index}`]: {
                    visible: isUserRetentionAgent
                },
                [`eSignatureUserRetentionAgentContainer${index}`]: {
                    visible: adForm.signatureType.value.code === 'esignature'
                },
                [`notESignatureUserRetentionAgentContainer${index}`]: {
                    visible: adForm.signatureType.value.code !== 'esignature'
                },
                [`userRetentionAgentDateSigned${index}`]: {
                    visible: adForm.isSigned.value === true,
                    date: adForm.signedDateTime.value,
                    format: 'short'
                },
                [`userRetentionAgentNotSigned${index}`]: {
                    visible: adForm.isSigned.value !== true
                },
                [`notUserRetentionAgentDateSignedContainer${index}`]: {
                    visible: !isUserRetentionAgent
                },
                [`notUserRetentionAgentDateSigned${index}`]: {
                    visible: adForm.isSigned.value === true,
                    content: `${convertDateToUTC(adForm.signedDateTime.value)} ${translator(messages.ut)}`
                },
                [`notUserRetentionAgentNotSigned${index}`]: {
                    visible: adForm.isSigned.value !== true
                },
                [`formLanguageSelectedContainer${index}`]: {
                    visible: !_.isNil(adForm.formLanguage.value)
                },
                [`viewEnglishDocument${index}`]: {
                    onClick: () => viewDocument(adForm)
                },
                [`viewSpanishDocument${index}`]: {
                    onClick: () => viewDocument(adForm)
                },
                [`viewDocument${index}`]: {
                    visible: _.isNil(adForm.formLanguage.value),
                    onClick: () => viewDocument(adForm)
                }
            }
        })
        return Object.assign({}, ...overrides);
    };

    const overrideProps  = {
        uwIssuePanel: {
            visible: !_.isEmpty(uwIssues),
            uwIssues,
            jobID: quoteID,
            hideIfAllApproved: true,
            blockingUWIssuesPresentCallback,
            approvedAllBlockingUWIssuesCallback ,
            submissionVM,
            setIsFileUploadDone,
            FromAvailableDocuments:true,
            updateWizardData
        },
        notUserRetentionPageDesc: {
            visible: !isUserRetentionAgent,
            content: (
                <FormattedMessage
                    {...messages.allDocsSigned}
                    values={{
                        requiredDocuments: <strong>{translator(messages.requiredDocuments)}</strong>
                    }}
                />
            )
        },
        userRetentionPageDesc: {
            visible: isUserRetentionAgent,
            content: (
                <FormattedMessage
                    {...messages.docsRetained}
                    values={{
                        followingDocuments: <strong>{translator(messages.followingDocuments)}</strong>
                    }}
                />
            )
        },
        availableDocumentsFormsIterable: {
            data: filteredForms
        },
        mlScriptComponent: {
            visible:  !_.isEmpty(scriptML),
            mlScript: scriptML
        },
        ...generateAdFormsOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent,
            mluwissuespanelcomponent: MLUWIssuesPanelComponent
        },
        resolveClassNameMap: styles
    }
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

AvailableDocumentsComponent.propTypes = {
    availableDocumentsForms: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isUserRetentionAgent: PropTypes.bool.isRequired,
    convertDateToUTC: PropTypes.func.isRequired,
    scriptML: PropTypes.shape({}).isRequired,
    viewDocument: PropTypes.func.isRequired,
    uwIssues: PropTypes.arrayOf(PropTypes.shape({})),
    quoteID: PropTypes.string,
    blockingUWIssuesPresentCallback: PropTypes.func.isRequired,
    approvedAllBlockingUWIssuesCallback: PropTypes.func.isRequired
};

AvailableDocumentsComponent.defaultProps = {
    uwIssues: []
};

export default AvailableDocumentsComponent;
